import { Head } from "@inertiajs/react"
import { Construction } from "lucide-react"
import { AppLayout } from "@/layouts/app-layout"
import { PageHeader } from "@/hooks/use-page-header"
import { Card, CardContent } from "@/components/ui/card"

function Dashboard() {
  return (
    <>
      <Head title="Tableau de bord" />
      <PageHeader title="Tableau de bord" />
      <div className="flex items-center justify-center py-32">
        <Card className="max-w-md text-center">
          <CardContent className="flex flex-col items-center gap-4 p-10">
            <Construction className="h-12 w-12 text-muted-foreground" />
            <div>
              <h2 className="text-lg font-semibold">Page en construction</h2>
              <p className="text-sm text-muted-foreground">
                Cette page est en cours de développement. Revenez bientôt !
              </p>
            </div>
          </CardContent>
        </Card>
      </div>
    </>
  )
}

Dashboard.layout = (page: React.ReactNode) => <AppLayout>{page}</AppLayout>

export default Dashboard
